import React from "react";
import BooksForYouCard from "./BooksForYouCard";
import SectionCarouselNav from "./SectionCarouselNav";
import { useHorizontalCarousel } from "../hooks/useHorizontalCarousel";
import "./BooksForYouSection.css";

const BooksForYouSection = ({
  handbook,
  highlightedAnchorId = null,
  onOpenBook,
  onBuyBook,
}) => {
  const books = handbook?.books ?? [];
  const title = handbook?.title || "Books for You";

  const {
    viewportRef,
    trackRef,
    trackOffset,
    canScrollLeft,
    canScrollRight,
    hasOverflow,
    scrollByPage,
  } = useHorizontalCarousel(books.length);

  if (!books.length) return null;

  return (
    <section className="dashboard-books-for-you" aria-label={title}>
      <div className="dashboard-books-for-you__intro">
        <h2 className="dashboard-books-for-you__title">{title}</h2>
        {hasOverflow ? (
          <SectionCarouselNav
            canScrollLeft={canScrollLeft}
            canScrollRight={canScrollRight}
            onPrev={() => scrollByPage(-1)}
            onNext={() => scrollByPage(1)}
            ariaLabel={`${title} navigation`}
          />
        ) : null}
      </div>

      <div className="dashboard-books-for-you__carousel">
        <div ref={viewportRef} className="dashboard-books-for-you__viewport">
          <div
            ref={trackRef}
            className="dashboard-books-for-you__track"
            style={{ transform: `translate3d(-${trackOffset}px, 0, 0)` }}
          >
            {books.map((book) => (
              <BooksForYouCard
                key={book.p_id}
                book={book}
                highlightedAnchorId={highlightedAnchorId}
                onBuy={() => onBuyBook(book)}
                onDetails={() => onOpenBook(book)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BooksForYouSection;
